import styled from "styled-components";
import {Section} from '../../styled/index'

const StyledSection = styled(Section)`
    display: flex;
    justify-content: space-between;
`
export default StyledSection
